import {useEffect, useState} from "react";
import {getTextScripts} from "@/actions/scripts/actions";
import type {TextScript} from "@/types/campaigns";

const NO_NAMES: ReadonlyMap<string, string> = new Map();
let inFlight: Promise<TextScript[]> | null = null;

/** Surfaces mounted together share one request; a later mount reads fresh names. */
function loadTextScripts() {
   inFlight ??= getTextScripts().finally(() => { inFlight = null; });
   return inFlight;
}

/** Text script names by ID for display. An unknown ID stays unresolved, never guessed. */
export function useTextScriptNames(enabled: boolean): ReadonlyMap<string, string> {
   const [names, setNames] = useState(NO_NAMES);
   useEffect(() => {
      if (!enabled) return;
      let current = true;
      loadTextScripts()
         .then(scripts => { if (current) setNames(new Map(scripts.map(script => [script.id.toLowerCase(), script.name]))); })
         // Names are a convenience; the review still shows each raw ID.
         .catch(error => console.error("Failed to load text script names for a proposal review:", error));
      return () => { current = false; };
   }, [enabled]);
   return names;
}
